import { useEffect } from 'react';
import useStores from '$src/hooks/useStores';

export default function usePreferences(userId, locationId, setFetchingPreferences) {
  const {
    preferencesStore: { fetchPreferences },
  } = useStores();

  useEffect(() => {
    async function getPreferences() {
      await fetchPreferences(userId, locationId);
      setFetchingPreferences(false);
    }
    if (locationId && userId) getPreferences();
  }, [fetchPreferences, locationId, userId, setFetchingPreferences]);
}
